module.exports = __webpack_public_path__ + "static/mo16-a8528fae16a0fb8ff80bdf0be6a1022f.png";